import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import { ThemeContext } from "../../context/ThemeProvider";
import Body from "../../ui/Body";


import Edit from "./Edit";
export default function Editkacoupon() {

  // theme context


  let navigate = useNavigate();


  return (
    <>
      {/* navigation section */}
      <Sidebar />
      <Nabvar />

      {/* body */}
      <Body

      >
        <Typography style={{ color: "#646777", fontWeight: "800" }}>Edit Coupon</Typography>
        <Edit />

      </Body>
    </>
  );
}
